// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"028990de","378":"2ae4a509","825":"74ba5477"}[chunkId] + ".chunk.js";
};